import React, { Children, isValidElement, useMemo, useRef } from 'react'
import {
  NavigationContextProvider,
  useNavigationContext,
} from './navigation-context'

export const NavigationMenu: React.FC<React.PropsWithChildren> = ({
  children,
}) => {
  const buttonRef = useRef<HTMLElement>(null)
  const { isOpen, onOpen, onClose, onMouseEnter, onClickButton } =
    useNavigationContext()
  const items = useMemo(() => {
    return Children.map(children, child => {
      if (!isValidElement(child)) {
        return child
      }
      return (
        <NavigationContextProvider
          value={{
            buttonRef,
            isMenu: true,
            isOpen,
            onClick(event) {
              onClickButton?.(event, child.props.data)
              if (isOpen) {
                onClose?.()
              } else {
                onOpen?.()
              }
            },
            onMouseEnter(event) {
              onMouseEnter?.(event)
            },
          }}
        >
          {child}
        </NavigationContextProvider>
      )
    })
  }, [children, isOpen, onClickButton, onClose, onMouseEnter, onOpen])

  return <>{items}</>
}
